import React, { useEffect, useState } from "react";
import "../../Modules/Tickets/Ticketslist.css";
import clock from "../../Assets/svg/clock.svg";
import subTicketIcon from "../../Assets/svg/sub-ticket-icon.svg";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import StatusUpdateModal from "./modal/status-update.js";
import { Toast, ToastContainer } from "react-bootstrap";
import LoaderModal from "../common/Loader.js";
import { useGlobal } from "../../GlobalContext.js";
import { useNavigate } from "react-router-dom";
import { apiCall } from "../../services/api-service.js";
import { getEnabledFieldApi } from "./Ticketapi.js";

const Ticketcardview = ({ tableData, refreshList }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  console.log(tableData);
  const [loading, setLoading] = useState(false);
  const { rolePermissionList } = useGlobal();
  const [openTicketList, setOpenTicketList] = useState([]);
  const [progressTicketList, setProgressTicketList] = useState([]);
  const [holdTicketList, setHoldTicketList] = useState([]);
  const [closedTicketList, setClosedTicketList] = useState([]);
  const [completedTicketList, setCompletedTicketList] = useState([]);
  const [openTotalRec, setOpenTotalRec] = useState(0);
  const [progressTotalRec, setProgressTotalRec] = useState(0);
  const [holdTotalRec, setHoldTotalRec] = useState(0);
  const [closedTotalRec, setClosedTotalRec] = useState(0);
  const [completedTotalRec, setCompletedTotalRec] = useState(0);
  const [enabledFields, setEnabledFields] = useState([]);
  const [fieldLabels, setFieldLabels] = useState({});

  const getEnabledField = async () => {
    try {
      const response = await getEnabledFieldApi();
      if (response?.status === 200 && response.data?.success === true) {
        setEnabledFields(response.data.enabled_fields || []);
        setFieldLabels(response.data.application_labels || response.data.labels || {});
      }
    } catch (err) {
      console.error("Error fetching enabled fields:", err);
    }
  };

  useEffect(() => {
    getEnabledField();
  }, []);

  const getFieldLabel = (fieldKey, defaultLabel) => {
    let custom = fieldLabels?.[fieldKey];
    if ((!custom || typeof custom !== "string" || custom.trim() === "") && (fieldKey === "Customer" || fieldKey === "Client Name")) {
      custom = fieldLabels?.["Customer"] || fieldLabels?.["Client Name"];
    }
    if (custom && typeof custom === "string" && custom.trim() !== "") {
      return custom.trim();
    }
    return defaultLabel;
  };

  useEffect(() => {
    setOpenTicketList(tableData.filter((item) => item.status === "Open") ?? []);
    setProgressTicketList(
      tableData.filter((item) => item.status === "In Progress" || item.status === "In-Progress") ?? []
    );
    setHoldTicketList(tableData.filter((item) => item.status === "Hold") ?? []);
    setClosedTicketList(
      tableData.filter((item) => item.status === "Closed") ?? []
    );
    setCompletedTicketList(
      tableData.filter((item) => item.status === "Completed") ?? []
    );

    const open = tableData.find((item) => item.status === "Open") || {};
    const inProgress =
      tableData.find((item) => item.status === "In Progress" || item.status === "In-Progress") || {};
    const hold = tableData.find((item) => item.status === "Hold") || {};
    const closed = tableData.find((item) => item.status === "Closed") || {};
    const completed =
      tableData.find((item) => item.status === "Completed") || {};

    setOpenTotalRec(open.total_rec ?? 0);

    setProgressTotalRec(inProgress.total_rec ?? 0);

    setHoldTotalRec(hold.total_rec ?? 0);

    setClosedTotalRec(closed.total_rec ?? 0);

    setCompletedTotalRec(completed.total_rec ?? 0);
  }, [tableData]);
  function checkPermission(permission) {
    return rolePermissionList.findIndex(
      (element) =>
        element["name"] === "Ticket" &&
        element["menu_permission"] === true &&
        element[permission] === true
    ) > -1
      ? true
      : false;
  }
  const navigate = useNavigate();
  const [showStatusUpdate, setShowStatusUpdate] = useState(false);
  /* const openTicketList=tableData.filter(item => item.status ==='Open')??[];
  const progressTicketList=tableData.filter(item => item.status ==='In Progress')??[];
  const holdTicketList=tableData.filter(item => item.status ==='Hold')??[];
  const closedTicketList=tableData.filter(item => item.status ==='Closed')??[];
  const completedTicketList=tableData.filter(item => item.status ==='Completed')??[]; */
  const [dragResult, setDragResult] = useState(null);
  const [dragSourceResult, setDragSourceResult] = useState(null);
  const [dragDestinationResult, setDragDestinationResult] = useState(null);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [updateStatus, setUpdateStatus] = useState(null);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const [dragSource, setDragSource] = useState(null);

  // Store source droppableId when dragging starts
  const handleDragStart = (start) => {
    console.log("Dragging start:", start);
    console.log("Dragging from:", start.source.droppableId);
    setDragSource(start.source.droppableId);
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;
    const { source, destination } = result;
    setDragResult(result);
    setDragSourceResult(source.droppableId);
    setDragDestinationResult(destination.droppableId);

    // Open to In Progress
    if (
      source.droppableId === "openList" &&
      destination.droppableId === "inprogressList"
    ) {
      const tempOpenList = [...openTicketList];
      statusUpdateApi(
        "In Progress",
        tempOpenList[0].tickets[source.index].id,
        source,
        destination
      );
      /*  const tempInProgressList=[...progressTicketList];
    const [movedItem] = tempOpenList[0].tickets.splice(source.index, 1);
   
    movedItem["status"]= "In Progress";
    console.log('movedItem item',movedItem);
    tempInProgressList[0].tickets.splice(destination.index, 0, movedItem);
    console.log(tempOpenList);
    setOpenTicketList(tempOpenList)
    setProgressTicketList(tempInProgressList) */
    }

    // In Progress to Hold
    if (
      source.droppableId === "inprogressList" &&
      destination.droppableId === "holdList"
    ) {
      const tempInProgressList = [...progressTicketList];
      // const tempHoldList=[...holdTicketList];
      //const [movedItem] = tempInProgressList[0].tickets[source.index];
      setSelectedTicket(tempInProgressList[0].tickets[source.index]);
      setUpdateStatus("Hold");
      setShowStatusUpdate(true);
      /*  movedItem["status"]= "Hold";
    console.log('movedItem item',movedItem);
    tempHoldList[0].tickets.splice(destination.index, 0, movedItem);
    setProgressTicketList(tempInProgressList)
    setHoldTicketList(tempHoldList) */
    }

    // Hold to In Progress
    if (
      source.droppableId === "holdList" &&
      destination.droppableId === "inprogressList"
    ) {
      const tempHoldList = [...holdTicketList];
      statusUpdateApi(
        "In Progress",
        tempHoldList[0].tickets[source.index].id,
        source,
        destination
      );
      /*     const tempInProgressList=[...progressTicketList];
    const tempHoldList=[...holdTicketList];
    const [movedItem] = tempHoldList[0].tickets.splice(source.index, 1);
    movedItem["status"]= "In Progress";
    console.log('movedItem item',movedItem);
    tempInProgressList[0].tickets.splice(destination.index, 0, movedItem);    
    setHoldTicketList(tempHoldList)
    setProgressTicketList(tempInProgressList) */
    }
    // In Progress to Closed
    if (
      source.droppableId === "inprogressList" &&
      destination.droppableId === "closedList"
    ) {
      const tempInProgressList = [...progressTicketList];
      /* const tempClosedList=[...closedTicketList];
    const [movedItem] = tempInProgressList[0].tickets.splice(source.index, 1);
    movedItem["status"]= "Closed";
    console.log('movedItem item',movedItem);
    tempClosedList[0].tickets.splice(destination.index, 0, movedItem);
    setProgressTicketList(tempInProgressList)
    setClosedTicketList(tempClosedList) */

      setSelectedTicket(tempInProgressList[0].tickets[source.index]);
      setUpdateStatus("Closed");
      setShowStatusUpdate(true);
    }

    // Closed to Completed
    if (
      source.droppableId === "closedList" &&
      destination.droppableId === "completedList"
    ) {
      const tempClosedList = [...closedTicketList];
      /*  const tempCompletedList=[...completedTicketList];
        const [movedItem] = tempClosedList[0].tickets.splice(source.index, 1);
        movedItem["status"]= "Completed";
        console.log('movedItem item',movedItem);
        tempCompletedList[0].tickets.splice(destination.index, 0, movedItem);        
        setClosedTicketList(tempClosedList)
        setCompletedTicketList(tempCompletedList) */

      setSelectedTicket(tempClosedList[0].tickets[source.index]);
      setUpdateStatus("Completed");
      setShowStatusUpdate(true);
    }
  };
  const statusUpdateApi = async (statusUpdate, id, source, destination) => {
    setLoading(true);
    try {
      const data = {
        status: statusUpdate,
      };
      const response = await apiCall("put", `ticket/status_update/${id}`, data);
      if (response?.status === 200 && response.data?.success === true) {
        if (
          source.droppableId === "openList" &&
          destination.droppableId === "inprogressList"
        ) {
          const tempOpenList = [...openTicketList];
          const tempInProgressList = [...progressTicketList];
          const [movedItem] = tempOpenList[0].tickets.splice(source.index, 1);

          movedItem["status"] = "In Progress";
          tempInProgressList[0].tickets.splice(destination.index, 0, movedItem);
          setOpenTicketList(tempOpenList);
          setProgressTicketList(tempInProgressList);
        }
        if (
          source.droppableId === "holdList" &&
          destination.droppableId === "inprogressList"
        ) {
          const tempInProgressList = [...progressTicketList];
          const tempHoldList = [...holdTicketList];
          const [movedItem] = tempHoldList[0].tickets.splice(source.index, 1);
          movedItem["status"] = "In Progress";
          tempInProgressList[0].tickets.splice(destination.index, 0, movedItem);
          setHoldTicketList(tempHoldList);
          setProgressTicketList(tempInProgressList);
        }
        refreshList?.();
      } else {
        setSnackbarMessage(response?.data?.message ?? "Something went wrong");
        setSnackbarStatus(response?.data?.status === true);
        handleSnackbarShow();
      }
    } finally {
      setLoading(false);
    }
  };
  function onSuccessStatus() {
    /*  const { source, destination } = dragResult; */
    const source = dragSourceResult;
    const destination = dragDestinationResult;
    if (
      source.droppableId === "openList" &&
      destination.droppableId === "inprogressList"
    ) {
      const tempOpenList = [...openTicketList];
      const tempInProgressList = [...progressTicketList];
      const [movedItem] = tempOpenList[0].tickets.splice(source.index, 1);

      movedItem["status"] = "In Progress";
      tempInProgressList[0].tickets.splice(destination.index, 0, movedItem);
      setOpenTicketList(tempOpenList);
      setProgressTicketList(tempInProgressList);
    }
    // In Progress to Hold
    if (
      source.droppableId === "inprogressList" &&
      destination.droppableId === "holdList"
    ) {
      const tempInProgressList = [...progressTicketList];
      const tempHoldList = [...holdTicketList];
      const [movedItem] = tempInProgressList[0].tickets.splice(source.index, 1);
      movedItem["status"] = "Hold";
      tempHoldList[0].tickets.splice(destination.index, 0, movedItem);
      setProgressTicketList(tempInProgressList);
      setHoldTicketList(tempHoldList);
    }
    //Hold to In Progress
    if (
      source.droppableId === "holdList" &&
      destination.droppableId === "inprogressList"
    ) {
      const tempInProgressList = [...progressTicketList];
      const tempHoldList = [...holdTicketList];
      const [movedItem] = tempHoldList[0].tickets.splice(source.index, 1);
      movedItem["status"] = "In Progress";
      tempInProgressList[0].tickets.splice(destination.index, 0, movedItem);
      setHoldTicketList(tempHoldList);
      setProgressTicketList(tempInProgressList);
    }
    // In Progress to Closed
    if (
      source.droppableId === "inprogressList" &&
      destination.droppableId === "closedList"
    ) {
      const tempInProgressList = [...progressTicketList];
      const tempClosedList = [...closedTicketList];
      const [movedItem] = tempInProgressList[0].tickets.splice(source.index, 1);
      movedItem["status"] = "Closed";
      tempClosedList[0].tickets.splice(destination.index, 0, movedItem);
      setProgressTicketList(tempInProgressList);
      setClosedTicketList(tempClosedList);
    }

    // Closed to Completed
    if (
      source.droppableId === "closedList" &&
      destination.droppableId === "completedList"
    ) {
      const tempClosedList = [...closedTicketList];
      const tempCompletedList = [...completedTicketList];
      const [movedItem] = tempClosedList[0].tickets.splice(source.index, 1);
      movedItem["status"] = "Completed";
      tempCompletedList[0].tickets.splice(destination.index, 0, movedItem);
      setClosedTicketList(tempClosedList);
      setCompletedTicketList(tempCompletedList);
    }
    setShowStatusUpdate(false);
    setSnackbarMessage("Status updated successfully!");
    setSnackbarStatus(true);
    handleSnackbarShow();
    refreshList?.();
  };

  const getPriorityColor = (p) => {
    switch (p) {
      case "High": return "#F44336";
      case "Medium": return "#FFC107";
      case "Low": return "#4CAF50";
      default: return "#E0E0E0";
    }
  };
  return (
    <>
      {showStatusUpdate && (
        <StatusUpdateModal
          ticketDetail={selectedTicket}
          statusUpdate={updateStatus}
          success={onSuccessStatus}
          onHide={() => {
            setShowStatusUpdate(false);
          }}
        />
      )}
      <div
        style={{
          backgroundColor: "#FFFFFF",
          borderRadius: "12px",
          margin: "16px",
          overflowX: "auto",
          whiteSpace: "nowrap",
          width: "100%",
        }}
      >
        <DragDropContext
          onDragStart={handleDragStart}
          onDragEnd={handleDragEnd}
        >
          <div
            style={{
              borderRadius: "24px",
              padding: "16px",
              gap: "16px",
              display: "flex",
              justifyContent: "space-between",
              flex: "5",
            }}
          >
            <Droppable
              key={"openList"}
              droppableId={"openList"}
              isDropDisabled={true}
            >
              {(provided) => (
                <div
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  style={{
                    width: "362px",
                    borderRadius: "12px",
                    flex: "1",
                    backgroundColor: "#F6F7F8",
                    padding: "16px",
                  }}
                >
                  <div style={{ width: "auto", minWidth: "58px" }}>
                    <div
                      style={{
                        fontFamily: "Satoshi",
                        fontWeight: "700",
                        fontSize: "12px",
                        color: "#212129",
                      }}
                    >
                      OPEN({openTotalRec})
                    </div>
                  </div>
                  <div
                    style={{
                      marginTop: "8px",
                      gap: "16px",
                      overflowY: "scroll",
                      whiteSpace: "nowrap",
                      height: "calc(100vh - 240px)",
                      scrollbarWidth: "none",
                      msOverflowStyle: "none",
                    }}
                  >
                    {openTicketList.length > 0 &&
                      openTicketList[0].tickets.map((item, index) => (
                        <Draggable
                          key={item.id}
                          draggableId={item.id.toString()}
                          index={index}
                        >
                          {(provided) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              key={"open-ticket-" + index}
                              onClick={(e) => {
                                if (
                                  checkPermission("view_permission") === false
                                ) {
                                  e.preventDefault(); // Prevent navigation
                                } else {
                                  navigate(`/ticket/view/${item.id}`);
                                }
                              }}
                              className="ticket-card-listing"
                              style={{
                                cursor: "pointer",
                                borderRadius: "12px",
                                padding: "16px",
                                paddingBottom: "16px",
                                paddingTop: "16px",
                                gap: "10px",
                                background: "#FFFFFF",
                                marginBottom: "10px",
                                ...provided.draggableProps.style,
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <span
                                  style={{
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    fontFamily: "Satoshi",
                                    fontWeight: "500",
                                    fontSize: "13px",
                                    lineHeight: "17.55px",
                                    color: "#212129",
                                  }}
                                >
                                  {item.code} {"-"} {item.title}{" "}
                                  {item.is_sub === true && (
                                    <img
                                      src={subTicketIcon}
                                      style={{
                                        width: "16px",
                                        height: "16px",
                                        marginLeft: "8px",
                                        marginTop: "-5px",
                                      }}
                                    />
                                  )}{" "}
                                </span>
                                <div
                                  style={{
                                    width: "24px",
                                    height: "23.38px",
                                    marginLeft: "57px",
                                  }}
                                >
                                  {/*  <img src={set} style={{width:'2.4px',height:'10.52px'}}/> */}
                                </div>
                              </div>
                              <div
                                style={{
                                  fontFamily: "Satoshi",
                                  fontWeight: "400",
                                  fontSize: "12px",
                                  lineHeight: "16.2px",
                                  color: "#8790A1",
                                  paddingBottom: "12px",
                                }}
                              >
                                {getFieldLabel("Expected Date", "Due")} {item.date}{" "}
                                <span
                                  style={{
                                    fontFamily: "Satoshi",
                                    fontWeight: "700",
                                    fontSize: "12px",
                                    lineHeight: "16.2px",
                                    color: "#6929E2",
                                  }}
                                >
                                    {item.status}
                                </span>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div style={{ display: "flex" }}>
                                  <div
                                    title={getFieldLabel("Estimation", "Estimation")}
                                    style={{
                                      height: "24px",
                                      borderRadius: "8px",
                                      padding: "6px 10px 6px 10px",
                                      backgroundColor: "#F6F7F8",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      marginRight: "16px",
                                    }}
                                  >
                                    <img
                                      src={clock}
                                      style={{
                                        width: "14px",
                                        height: "14px",
                                        margin: "0",
                                      }}
                                    />
                                    <span
                                      style={{
                                        paddingLeft: "6px",
                                        fontFamily: "Satoshi",
                                        fontWeight: "700",
                                        fontSize: "11px",
                                        lineHeight: "14.85px",
                                        color: "#212129",
                                        margin: "0",
                                      }}
                                    >
                                      {item.est ?? "00:00"} hrs
                                    </span>
                                  </div>
                                  <div
                                    title={getFieldLabel("Priority", "Priority")}
                                    style={{
                                      height: "24px",
                                      borderRadius: "4px",
                                      padding: "6px 10px 6px 10px",
                                      gap: "10px",
                                      backgroundColor:
                                        item.priority === "High"
                                          ? "#FF4444"
                                          : item.priority === "Medium"
                                          ? "#E8A700"
                                          : "#AD44FF",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontFamily: "Satoshi",
                                        fontWeight: "700",
                                        fontSize: "12px",
                                        lineHeight: "16.2px",
                                        color: "#FFFFFF",
                                        margin: "0",
                                      }}
                                    >
                                      {" "}
                                      {item.priority}
                                    </span>
                                  </div>
                                </div>
                                <div
                                  style={{
                                    width: "28px",
                                    height: "28px",
                                    borderRadius: "100px",
                                    backgroundColor: "#2A9D4A",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <span
                                    style={{
                                      fontFamily: "Satoshi",
                                      fontWeight: "700",
                                      fontSize: "12px",
                                      lineHeight: "16.2px",
                                      color: "#FFFFFF",
                                      margin: "0",
                                    }}
                                  >
                                    {item.user !== undefined &&
                                    item.user != null &&
                                    item.user !== ""
                                      ? item.user.substring(0, 2).toUpperCase()
                                      : ""}
                                  </span>
                                </div>
                              </div>
                            </div>
                          )}
                        </Draggable>
                      ))}
                  </div>
                </div>
              )}
            </Droppable>

            <Droppable
              key={"inprogressList"}
              droppableId={"inprogressList"}
              isDropDisabled={
                dragSource === "openList" || dragSource === "holdList"
                  ? false
                  : true
              }
            >
              {(provided) => (
                <div
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  className="inprogress"
                  style={{
                    width: "362px",
                    borderRadius: "12px",
                    flex: "1",
                    backgroundColor: "#F6F7F8",
                    padding: "16px",
                  }}
                >
                  <div style={{ width: "auto", minWidth: "92px" }}>
                    <div
                      style={{
                        fontFamily: "Satoshi",
                        fontWeight: "700",
                        fontSize: "12px",
                        lineHeight: "16.2px",
                        color: "#212129",
                      }}
                    >
                      INPROGRESS({progressTotalRec})
                    </div>
                  </div>
                  <div
                    style={{
                      marginTop: "8px",
                      gap: "16px",
                      overflowY: "scroll",
                      whiteSpace: "nowrap",
                      height: "calc(100vh - 240px)",
                      scrollbarWidth: "none",
                      msOverflowStyle: "none",
                    }}
                  >
                    {progressTicketList.length > 0 &&
                      progressTicketList[0].tickets.map((item, index) => (
                        <Draggable
                          key={item.id}
                          draggableId={item.id.toString()}
                          index={index}
                        >
                          {(provided) => {
                            const [time, milliseconds] = item.duration?.split(
                              "."
                            ) || ["00:00", ""];
                            return (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                onClick={(e) => {
                                  if (
                                    checkPermission("view_permission") === false
                                  ) {
                                    e.preventDefault(); // Prevent navigation
                                  } else {
                                    navigate(`/ticket/view/${item.id}`);
                                  }
                                }}
                                key={"progress-ticket-" + index}
                                className="ticket-card-listing"
                                style={{
                                  cursor: "pointer",
                                  borderRadius: "12px",
                                  padding: "16px",
                                  paddingBottom: "16px",
                                  paddingTop: "16px",
                                  gap: "10px",
                                  background: "#FFFFFF",
                                  marginBottom: "10px",
                                  ...provided.draggableProps.style,
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <span
                                    style={{
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      fontFamily: "Satoshi",
                                      fontWeight: "500",
                                      fontSize: "13px",
                                      lineHeight: "17.55px",
                                      color: "#212129",
                                    }}
                                  >
                                    {item.code} {"-"} {item.title}{" "}
                                    {item.is_sub === true && (
                                      <img
                                        src={subTicketIcon}
                                        style={{
                                          width: "16px",
                                          height: "16px",
                                          marginLeft: "8px",
                                          marginTop: "-5px",
                                        }}
                                      />
                                    )}{" "}
                                  </span>
                                  <div
                                    style={{
                                      width: "24px",
                                      height: "23.38px",
                                      marginLeft: "57px",
                                    }}
                                  >
                                    {/*  <img src={set} style={{width:'2.4px',height:'10.52px'}}/> */}
                                  </div>
                                </div>
                                <div
                                  style={{
                                    fontFamily: "Satoshi",
                                    fontWeight: "400",
                                    fontSize: "12px",
                                    lineHeight: "16.2px",
                                    color: "#8790A1",
                                    paddingBottom: "12px",
                                  }}
                                >
                                  {getFieldLabel("Expected Date", "Due")} {item.date}{" "}
                                  <span
                                    style={{
                                      fontFamily: "Satoshi",
                                      fontWeight: "700",
                                      fontSize: "12px",
                                      lineHeight: "16.2px",
                                      color: "#6929E2",
                                    }}
                                  >
                                    {item.status}
                                  </span>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <div style={{ display: "flex" }}>
                                    <div
                                      title={getFieldLabel("Estimation", "Estimation")}
                                      style={{
                                        height: "24px",
                                        borderRadius: "8px",
                                        padding: "6px 10px 6px 10px",
                                        backgroundColor: "#F6F7F8",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        marginRight: "16px",
                                      }}
                                    >
                                      <img
                                        src={clock}
                                        style={{
                                          width: "14px",
                                          height: "14px",
                                          margin: "0",
                                        }}
                                      />
                                      <span
                                        style={{
                                          paddingLeft: "6px",
                                          fontFamily: "Satoshi",
                                          fontWeight: "700",
                                          fontSize: "11px",
                                          lineHeight: "14.85px",
                                          color: "#212129",
                                          margin: "0",
                                        }}
                                      >
                                        {item.est ?? "00:00"} hrs
                                      </span>
                                    </div>
                                    <div
                                      title={getFieldLabel("Priority", "Priority")}
                                      style={{
                                        height: "24px",
                                        borderRadius: "4px",
                                        padding: "6px 10px 6px 10px",
                                        gap: "10px",
                                        backgroundColor: getPriorityColor(item.priority),
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      <span
                                        style={{
                                          fontFamily: "Satoshi",
                                          fontWeight: "700",
                                          fontSize: "12px",
                                          lineHeight: "16.2px",
                                          color: "#FFFFFF",
                                          margin: "0",
                                        }}
                                      >
                                        {" "}
                                        {item.priority}
                                      </span>
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      width: "28px",
                                      height: "28px",
                                      borderRadius: "100px",
                                      backgroundColor: "#2A9D4A",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontFamily: "Satoshi",
                                        fontWeight: "700",
                                        fontSize: "12px",
                                        lineHeight: "16.2px",
                                        color: "#FFFFFF",
                                        margin: "0",
                                      }}
                                    >
                                      {item.user !== undefined &&
                                      item.user != null &&
                                      item.user !== ""
                                        ? item.user
                                            .substring(0, 2)
                                            .toUpperCase()
                                        : ""}
                                    </span>
                                  </div>
                                </div>
                                <div
                                  style={{
                                    width: "298px",
                                    height: "28px",
                                    borderRadius: "27px",
                                    padding: "6px 12px 6px 12px",
                                    gap: "8px",
                                    backgroundColor: "#EBEEFF",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    marginTop: "20px",
                                  }}
                                >
                                  <img
                                    src={clock}
                                    style={{
                                      width: "14px",
                                      height: "14px",
                                      margin: "0",
                                    }}
                                    alt=""
                                  />
                                  <span
                                    style={{
                                      fontFamily: "Satoshi",
                                      fontWeight: "500",
                                      fontSize: "12px",
                                      lineHeight: "16.2px",
                                      color: "#212129",
                                      margin: "0",
                                    }}
                                  >
                                    {getFieldLabel("Work Duration", "Working duration")}{" "}
                                    <span
                                      style={{
                                        fontFamily: "Satoshi",
                                        fontWeight: "900",
                                        fontSize: "12px",
                                        lineHeight: "16.2px",
                                        color: "#212129",
                                        margin: "0",
                                      }}
                                    >
                                      - {time ?? "00:00"} hrs
                                    </span>
                                  </span>
                                </div>
                              </div>
                            );
                          }}
                        </Draggable>
                      ))}
                  </div>
                </div>
              )}
            </Droppable>
            <Droppable
              key={"holdList"}
              droppableId={"holdList"}
              isDropDisabled={dragSource === "inprogressList" ? false : true}
            >
              {(provided) => (
                <div
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  className="hold"
                  style={{
                    width: "362px",
                    borderRadius: "12px",
                    flex: "1",
                    backgroundColor: "#F6F7F8",
                    padding: "16px",
                  }}
                >
                  <div style={{ width: "auto", minWidth: "59px" }}>
                    <div
                      style={{
                        fontFamily: "Satoshi",
                        fontWeight: "700",
                        fontSize: "12px",
                        lineHeight: "16.2px",
                        color: "#212129",
                      }}
                    >
                      HOLD({holdTotalRec})
                    </div>
                  </div>

                  <div
                    style={{
                      marginTop: "8px",
                      gap: "16px",
                      overflowY: "scroll",
                      whiteSpace: "nowrap",
                      height: "calc(100vh - 240px)",
                      scrollbarWidth: "none",
                      msOverflowStyle: "none",
                    }}
                  >
                    {holdTicketList.length > 0 &&
                      holdTicketList[0].tickets.map((item, index) => (
                        <Draggable
                          key={item.id}
                          draggableId={item.id.toString()}
                          index={index}
                        >
                          {(provided) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              key={"hold-ticket-" + index}
                              onClick={(e) => {
                                if (
                                  checkPermission("view_permission") === false
                                ) {
                                  e.preventDefault(); // Prevent navigation
                                } else {
                                  navigate(`/ticket/view/${item.id}`);
                                }
                              }}
                              className="ticket-card-listing"
                              style={{
                                cursor: "pointer",
                                borderRadius: "12px",
                                padding: "16px",
                                paddingBottom: "16px",
                                paddingTop: "16px",
                                gap: "10px",
                                background: "#FFFFFF",
                                marginBottom: "10px",
                                ...provided.draggableProps.style,
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <span
                                  style={{
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    fontFamily: "Satoshi",
                                    fontWeight: "500",
                                    fontSize: "13px",
                                    lineHeight: "17.55px",
                                    color: "#212129",
                                  }}
                                >
                                  {item.code} {"-"} {item.title}{" "}
                                  {item.is_sub === true && (
                                    <img
                                      src={subTicketIcon}
                                      style={{
                                        width: "16px",
                                        height: "16px",
                                        marginLeft: "8px",
                                        marginTop: "-5px",
                                      }}
                                    />
                                  )}{" "}
                                </span>
                                <div
                                  style={{
                                    width: "24px",
                                    height: "23.38px",
                                    marginLeft: "57px",
                                  }}
                                >
                                  {/*  <img src={set} style={{width:'2.4px',height:'10.52px'}}/> */}
                                </div>
                              </div>
                              <div
                                style={{
                                  fontFamily: "Satoshi",
                                  fontWeight: "400",
                                  fontSize: "12px",
                                  lineHeight: "16.2px",
                                  color: "#8790A1",
                                  paddingBottom: "12px",
                                }}
                              >
                                {getFieldLabel("Expected Date", "Due")} {item.date}{" "}
                                <span
                                  style={{
                                    fontFamily: "Satoshi",
                                    fontWeight: "700",
                                    fontSize: "12px",
                                    lineHeight: "16.2px",
                                    color: "#6929E2",
                                  }}
                                >
                                  {item.status}
                                </span>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div style={{ display: "flex" }}>
                                  <div
                                    title={getFieldLabel("Estimation", "Estimation")}
                                    style={{
                                      height: "24px",
                                      borderRadius: "8px",
                                      padding: "6px 10px 6px 10px",
                                      backgroundColor: "#F6F7F8",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      marginRight: "16px",
                                    }}
                                  >
                                    <img
                                      src={clock}
                                      style={{
                                        width: "14px",
                                        height: "14px",
                                        margin: "0",
                                      }}
                                    />
                                    <span
                                      style={{
                                        paddingLeft: "6px",
                                        fontFamily: "Satoshi",
                                        fontWeight: "700",
                                        fontSize: "11px",
                                        lineHeight: "14.85px",
                                        color: "#212129",
                                        margin: "0",
                                      }}
                                    >
                                      {item.est ?? "00:00"} hrs
                                    </span>
                                  </div>
                                  <div
                                    title={getFieldLabel("Priority", "Priority")}
                                    style={{
                                      height: "24px",
                                      borderRadius: "4px",
                                      padding: "6px 10px 6px 10px",
                                      gap: "10px",
                                      backgroundColor:
                                        item.priority === "High"
                                          ? "#FF4444"
                                          : item.priority === "Medium"
                                          ? "#E8A700"
                                          : "#AD44FF",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontFamily: "Satoshi",
                                        fontWeight: "700",
                                        fontSize: "12px",
                                        lineHeight: "16.2px",
                                        color: "#FFFFFF",
                                        margin: "0",
                                      }}
                                    >
                                      {" "}
                                      {item.priority}
                                    </span>
                                  </div>
                                </div>
                                <div
                                  style={{
                                    width: "28px",
                                    height: "28px",
                                    borderRadius: "100px",
                                    backgroundColor: "#2A9D4A",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <span
                                    style={{
                                      fontFamily: "Satoshi",
                                      fontWeight: "700",
                                      fontSize: "12px",
                                      lineHeight: "16.2px",
                                      color: "#FFFFFF",
                                      margin: "0",
                                    }}
                                  >
                                    {item.user !== undefined &&
                                    item.user != null &&
                                    item.user !== ""
                                      ? item.user.substring(0, 2).toUpperCase()
                                      : ""}
                                  </span>
                                </div>
                              </div>
                            </div>
                          )}
                        </Draggable>
                      ))}
                  </div>
                </div>
              )}
            </Droppable>
            <Droppable
              key={"closedList"}
              droppableId={"closedList"}
              isDropDisabled={dragSource === "inprogressList" ? false : true}
            >
              {(provided) => (
                <div
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  className="closed"
                  style={{
                    width: "362px",
                    borderRadius: "12px",
                    flex: "1",
                    backgroundColor: "#F6F7F8",
                    padding: "16px",
                  }}
                >
                  <div style={{ width: "auto", minWidth: "92px" }}>
                    <div
                      style={{
                        fontFamily: "Satoshi",
                        fontWeight: "700",
                        fontSize: "12px",
                        lineHeight: "16.2px",
                        color: "#212129",
                      }}
                    >
                      CLOSED({closedTotalRec})
                    </div>
                  </div>

                  <div
                    style={{
                      marginTop: "8px",
                      gap: "16px",
                      overflowY: "scroll",
                      whiteSpace: "nowrap",
                      height: "calc(100vh - 240px)",
                      scrollbarWidth: "none",
                      msOverflowStyle: "none",
                    }}
                  >
                    {closedTicketList.length > 0 &&
                      closedTicketList[0].tickets.map((item, index) => (
                        <Draggable
                          key={item.id}
                          draggableId={item.id.toString()}
                          index={index}
                        >
                          {(provided) => {
                            const [workingDuration, milliseconds] =
                              item.duration?.split(".") || ["00:00", ""];
                            const [closedDuration, closedmilliseconds] =
                              item.closed_duration?.split(".") || ["00:00", ""];
                            return (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                key={"closed-ticket-" + index}
                                onClick={(e) => {
                                  if (
                                    checkPermission("view_permission") === false
                                  ) {
                                    e.preventDefault(); // Prevent navigation
                                  } else {
                                    navigate(`/ticket/view/${item.id}`);
                                  }
                                }}
                                className="ticket-card-listing"
                                style={{
                                  cursor: "pointer",
                                  borderRadius: "12px",
                                  padding: "16px",
                                  paddingBottom: "16px",
                                  paddingTop: "16px",
                                  gap: "10px",
                                  background: "#FFFFFF",
                                  marginBottom: "10px",
                                  ...provided.draggableProps.style,
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <span
                                    style={{
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      fontFamily: "Satoshi",
                                      fontWeight: "500",
                                      fontSize: "13px",
                                      lineHeight: "17.55px",
                                      color: "#212129",
                                    }}
                                  >
                                    {item.code} {"-"} {item.title}{" "}
                                    {item.is_sub === true && (
                                      <img
                                        src={subTicketIcon}
                                        style={{
                                          width: "16px",
                                          height: "16px",
                                          marginLeft: "8px",
                                          marginTop: "-5px",
                                        }}
                                      />
                                    )}{" "}
                                  </span>
                                  <div
                                    style={{
                                      width: "24px",
                                      height: "23.38px",
                                      marginLeft: "57px",
                                    }}
                                  >
                                    {/*  <img src={set} style={{width:'2.4px',height:'10.52px'}}/> */}
                                  </div>
                                </div>
                                <div
                                  style={{
                                    fontFamily: "Satoshi",
                                    fontWeight: "400",
                                    fontSize: "12px",
                                    lineHeight: "16.2px",
                                    color: "#8790A1",
                                    paddingBottom: "12px",
                                  }}
                                >
                                  {getFieldLabel("Expected Date", "Due")} {item.date}{" "}
                                  <span
                                    style={{
                                      fontFamily: "Satoshi",
                                      fontWeight: "700",
                                      fontSize: "12px",
                                      lineHeight: "16.2px",
                                      color: "#6929E2",
                                    }}
                                  >
                                    {item.status}
                                  </span>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <div style={{ display: "flex" }}>
                                    <div
                                      title={getFieldLabel("Estimation", "Estimation")}
                                      style={{
                                        height: "24px",
                                        borderRadius: "8px",
                                        padding: "6px 10px 6px 10px",
                                        backgroundColor: "#F6F7F8",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        marginRight: "16px",
                                      }}
                                    >
                                      <img
                                        src={clock}
                                        style={{
                                          width: "14px",
                                          height: "14px",
                                          margin: "0",
                                        }}
                                      />
                                      <span
                                        style={{
                                          paddingLeft: "6px",
                                          fontFamily: "Satoshi",
                                          fontWeight: "700",
                                          fontSize: "11px",
                                          lineHeight: "14.85px",
                                          color: "#212129",
                                          margin: "0",
                                        }}
                                      >
                                        {item.est ?? "00:00"} hrs
                                      </span>
                                    </div>
                                    <div
                                      title={getFieldLabel("Priority", "Priority")}
                                      style={{
                                        height: "24px",
                                        borderRadius: "4px",
                                        padding: "6px 10px 6px 10px",
                                        gap: "10px",
                                        backgroundColor: getPriorityColor(item.priority),
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      <span
                                        style={{
                                          fontFamily: "Satoshi",
                                          fontWeight: "700",
                                          fontSize: "12px",
                                          lineHeight: "16.2px",
                                          color: "#FFFFFF",
                                          margin: "0",
                                        }}
                                      >
                                        {" "}
                                        {item.priority}
                                      </span>
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      width: "28px",
                                      height: "28px",
                                      borderRadius: "100px",
                                      backgroundColor: "#2A9D4A",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontFamily: "Satoshi",
                                        fontWeight: "700",
                                        fontSize: "12px",
                                        lineHeight: "16.2px",
                                        color: "#FFFFFF",
                                        margin: "0",
                                      }}
                                    >
                                      {item.user !== undefined &&
                                      item.user != null &&
                                      item.user !== ""
                                        ? item.user
                                            .substring(0, 2)
                                            .toUpperCase()
                                        : ""}
                                    </span>
                                  </div>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    marginTop: "20px",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "141px",
                                      height: "52px",
                                      borderRadius: "12px",
                                      padding: "6px 12px 6px 12px",
                                      gap: "8px",
                                      backgroundColor: "#EBEEFF",
                                    }}
                                  >
                                    <img
                                      src={clock}
                                      style={{
                                        width: "14px",
                                        height: "14px",
                                        marginRight: "8px",
                                      }}
                                    />
                                    <span
                                      style={{
                                        fontFamily: "Satoshi",
                                        fontWeight: "500",
                                        fontSize: "12px",
                                        lineHeight: "16.2px",
                                        color: "#212129",
                                        margin: "0",
                                      }}
                                    >
                                      {getFieldLabel("Work Duration", "Worked duration")}
                                    </span>
                                    <p
                                      style={{
                                        fontFamily: "Satoshi",
                                        fontWeight: "900",
                                        fontSize: "12px",
                                        lineHeight: "16.2px",
                                        color: "#212129",
                                      }}
                                    >
                                      {workingDuration ?? "00:00"} hrs
                                    </p>
                                  </div>

                                  <div
                                    style={{
                                      width: "141px",
                                      height: "52px",
                                      borderRadius: "12px",
                                      padding: "6px 12px 6px 12px",
                                      gap: "8px",
                                      backgroundColor: "#EBEEFF",
                                    }}
                                  >
                                    <img
                                      src={clock}
                                      style={{
                                        width: "14px",
                                        height: "14px",
                                        marginRight: "8px",
                                      }}
                                    />
                                    <span
                                      style={{
                                        fontFamily: "Satoshi",
                                        fontWeight: "500",
                                        fontSize: "12px",
                                        lineHeight: "16.2px",
                                        color: "#212129",
                                        margin: "0",
                                      }}
                                    >
                                      {getFieldLabel("Closing Date", "Closed duration")}
                                    </span>
                                    <p
                                      style={{
                                        fontFamily: "Satoshi",
                                        fontWeight: "900",
                                        fontSize: "12px",
                                        lineHeight: "16.2px",
                                        color: "#212129",
                                      }}
                                    >
                                      {closedDuration ?? "00:00"} hrs
                                    </p>
                                  </div>
                                </div>
                              </div>
                            );
                          }}
                        </Draggable>
                      ))}
                  </div>
                </div>
              )}
            </Droppable>

            <Droppable
              key={"completedList"}
              droppableId={"completedList"}
              isDropDisabled={dragSource === "closedList" ? false : true}
            >
              {(provided) => (
                <div
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  className="completed"
                  style={{
                    width: "362px",
                    borderRadius: "12px",
                    backgroundColor: "#F6F7F8",
                    padding: "16px",
                  }}
                >
                  <div
                    style={{
                      width: "auto",
                      minWidth: "330px",
                      height: "16px",
                      marginBottom: "16px",
                    }}
                  >
                    <span
                      style={{
                        fontFamily: "Satoshi",
                        fontWeight: "700",
                        fontSize: "12px",
                        lineHeight: "16.2px",
                        color: "#212129",
                      }}
                    >
                      COMPLETED({completedTotalRec})
                    </span>
                  </div>
                  <div
                    style={{
                      marginTop: "16px",
                      gap: "16px",
                      overflowY: "scroll",
                      whiteSpace: "nowrap",
                      height: "calc(100vh - 240px)",
                      scrollbarWidth: "none",
                      msOverflowStyle: "none",
                    }}
                  >
                    {completedTicketList.length > 0 &&
                      completedTicketList[0].tickets.map((item, index) => (
                        <Draggable
                          key={item.id}
                          draggableId={item.id.toString()}
                          index={index}
                        >
                          {(provided) => {
                            const [workingDuration, milliseconds] =
                              item.duration?.split(".") || ["00:00", ""];
                            const [closedDuration, closedmilliseconds] =
                              item.closed_duration?.split(".") || ["00:00", ""];
                            return (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                key={"completed-ticket-" + index}
                                className="ticket-card-listing"
                                onClick={(e) => {
                                  if (
                                    checkPermission("view_permission") === false
                                  ) {
                                    e.preventDefault(); // Prevent navigation
                                  } else {
                                    navigate(`/ticket/view/${item.id}`);
                                  }
                                }}
                                style={{
                                  cursor: "pointer",
                                  borderRadius: "12px",
                                  padding: "16px",
                                  paddingBottom: "16px",
                                  paddingTop: "16px",
                                  gap: "10px",
                                  background: "#FFFFFF",
                                  marginBottom: "10px",
                                  ...provided.draggableProps.style,
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <span
                                    style={{
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      fontFamily: "Satoshi",
                                      fontWeight: "500",
                                      fontSize: "13px",
                                      lineHeight: "17.55px",
                                      color: "#212129",
                                    }}
                                  >
                                    {item.code} {"-"} {item.title}{" "}
                                    {item.is_sub === true && (
                                      <img
                                        src={subTicketIcon}
                                        style={{
                                          width: "16px",
                                          height: "16px",
                                          marginLeft: "8px",
                                          marginTop: "-5px",
                                        }}
                                      />
                                    )}{" "}
                                  </span>
                                  <div
                                    style={{
                                      width: "24px",
                                      height: "23.38px",
                                      marginLeft: "57px",
                                    }}
                                  >
                                    {/*  <img src={set} style={{width:'2.4px',height:'10.52px'}}/> */}
                                  </div>
                                </div>
                                <div
                                  style={{
                                    fontFamily: "Satoshi",
                                    fontWeight: "400",
                                    fontSize: "12px",
                                    lineHeight: "16.2px",
                                    color: "#8790A1",
                                    paddingBottom: "12px",
                                  }}
                                >
                                  {getFieldLabel("Expected Date", "Due")} {item.date}{" "}
                                  <span
                                    style={{
                                      fontFamily: "Satoshi",
                                      fontWeight: "700",
                                      fontSize: "12px",
                                      lineHeight: "16.2px",
                                      color: "#6929E2",
                                    }}
                                  >
                                    {item.status}
                                  </span>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <div style={{ display: "flex" }}>
                                    <div
                                      title={getFieldLabel("Estimation", "Estimation")}
                                      style={{
                                        height: "24px",
                                        borderRadius: "8px",
                                        padding: "6px 10px 6px 10px",
                                        backgroundColor: "#F6F7F8",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        marginRight: "16px",
                                      }}
                                    >
                                      <img
                                        src={clock}
                                        style={{
                                          width: "14px",
                                          height: "14px",
                                          margin: "0",
                                        }}
                                      />
                                      <span
                                        style={{
                                          paddingLeft: "6px",
                                          fontFamily: "Satoshi",
                                          fontWeight: "700",
                                          fontSize: "11px",
                                          lineHeight: "14.85px",
                                          color: "#212129",
                                          margin: "0",
                                        }}
                                      >
                                        {item.est ?? "00:00"} hrs
                                      </span>
                                    </div>
                                    <div
                                      title={getFieldLabel("Priority", "Priority")}
                                      style={{
                                        height: "24px",
                                        borderRadius: "4px",
                                        padding: "6px 10px 6px 10px",
                                        gap: "10px",
                                        backgroundColor: getPriorityColor(item.priority),
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      <span
                                        style={{
                                          fontFamily: "Satoshi",
                                          fontWeight: "700",
                                          fontSize: "12px",
                                          lineHeight: "16.2px",
                                          color: "#FFFFFF",
                                          margin: "0",
                                        }}
                                      >
                                        {" "}
                                        {item.priority}
                                      </span>
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      width: "28px",
                                      height: "28px",
                                      borderRadius: "100px",
                                      backgroundColor: "#2A9D4A",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontFamily: "Satoshi",
                                        fontWeight: "700",
                                        fontSize: "12px",
                                        lineHeight: "16.2px",
                                        color: "#FFFFFF",
                                        margin: "0",
                                      }}
                                    >
                                      {item.user !== undefined &&
                                      item.user != null &&
                                      item.user !== ""
                                        ? item.user
                                            .substring(0, 2)
                                            .toUpperCase()
                                        : ""}
                                    </span>
                                  </div>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    marginTop: "20px",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "141px",
                                      height: "52px",
                                      borderRadius: "12px",
                                      padding: "6px 12px 6px 12px",
                                      gap: "8px",
                                      backgroundColor: "#EBEEFF",
                                    }}
                                  >
                                    <img
                                      src={clock}
                                      style={{
                                        width: "14px",
                                        height: "14px",
                                        marginRight: "8px",
                                      }}
                                    />
                                    <span
                                      style={{
                                        fontFamily: "Satoshi",
                                        fontWeight: "500",
                                        fontSize: "12px",
                                        lineHeight: "16.2px",
                                        color: "#212129",
                                        margin: "0",
                                      }}
                                    >
                                      {getFieldLabel("Work Duration", "Worked duration")}
                                    </span>
                                    <p
                                      style={{
                                        fontFamily: "Satoshi",
                                        fontWeight: "900",
                                        fontSize: "12px",
                                        lineHeight: "16.2px",
                                        color: "#212129",
                                      }}
                                    >
                                      {workingDuration ?? "00:00"} hrs
                                    </p>
                                  </div>

                                  <div
                                    style={{
                                      width: "141px",
                                      height: "52px",
                                      borderRadius: "12px",
                                      padding: "6px 12px 6px 12px",
                                      gap: "8px",
                                      backgroundColor: "#EBEEFF",
                                    }}
                                  >
                                    <img
                                      src={clock}
                                      style={{
                                        width: "14px",
                                        height: "14px",
                                        marginRight: "8px",
                                      }}
                                    />
                                    <span
                                      style={{
                                        fontFamily: "Satoshi",
                                        fontWeight: "500",
                                        fontSize: "12px",
                                        lineHeight: "16.2px",
                                        color: "#212129",
                                        margin: "0",
                                      }}
                                    >
                                      {getFieldLabel("Closing Date", "Closed duration")}
                                    </span>
                                    <p
                                      style={{
                                        fontFamily: "Satoshi",
                                        fontWeight: "900",
                                        fontSize: "12px",
                                        lineHeight: "16.2px",
                                        color: "#212129",
                                      }}
                                    >
                                      {closedDuration ?? "00:00"} hrs
                                    </p>
                                  </div>
                                </div>
                              </div>
                            );
                          }}
                        </Draggable>
                      ))}
                  </div>
                </div>
              )}
            </Droppable>
          </div>
        </DragDropContext>
      </div>
      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          {/*  <Toast.Header>
            <strong className="mr-auto">Snackbar Title</strong>
          </Toast.Header> */}
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
      <LoaderModal show={loading} />
    </>
  );
};

export default Ticketcardview;
